import React from 'react';
import PropTypes from 'prop-types';
import './menu-icons.css';


const LastSearchIcon = props => {
  const { fill, className, onClick } = props;
  return (
    <svg
      viewBox="0 0 18 18"
      height="25px"
      width="25px"
      onClick={onClick && onClick}
      className={`pointer ${className ? className: ""}`}
    >
    <path d="M9,18 C4.02943725,18 0,13.9705627 0,9 C0,4.02943725 4.02943725,0 9,0 C13.9705627,0 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 Z" id="Mask" opacity="0.3" ></path>
    <path d="M8.96301557,3.5 L9.04750622,3.5 C9.30438194,3.5 9.51946472,3.69464724 9.54502481,3.95024814 L10,8.5 L10,8.5 L13.2480695,10.3560397 C13.403857,10.4450611 13.5,10.6107328 13.5,10.7901613 L13.5,11 C13.5,11.2109164 13.3290185,11.3818979 13.1181021,11.3818979 C13.0841582,11.3818979 13.0503659,11.3773725 13.0176181,11.3684413 L8.39866118,10.1087258 C8.16728244,10.0456225 8.01329857,9.82711861 8.03169264,9.58799562 L8.46448833,3.96165175 C8.48452668,3.70115317 8.70174742,3.5 8.96301557,3.5 Z" id="Path-107" ></path>
     </svg>
  );
};

// fill={fill ? fill : "#000"} 
// LastSearchIcon.propTypes = {
//   active: PropTypes.bool.isRequired,
//   label: PropTypes.bool.isRequired,
// };

export default LastSearchIcon;
